const BASE_URL = 'ai-service/api/ai-reports'

const aiReportRequests = {
  getAiReportPublishNameSettingsRequest: () => ({
    url: `tenant-service/api/config/aiReport/publishName`,
    method: 'get',
  }),
  getAiObjectAnalysisRequest: ({ contentId, aiObjectId, columns = null, search = null, searchFields = null }) => ({
    url: `${BASE_URL}/content/${contentId}/ai-object/${aiObjectId}`,
    method: 'post',
    data: { columns, search, searchFields },
  }),
  publishAiReportRequest: ({ contentId, aiObjectId, templateId, name, rewrite }) => ({
    url: `${BASE_URL}/content/${contentId}/ai-object/${aiObjectId}/publish`,
    method: 'post',
    data: { templateId: templateId === 0 ? null : templateId, name, rewrite },
  }),
  getDefaultPublishNameRequest: ({ aiObjectId }) => ({
    url: `${BASE_URL}/ai-object/${aiObjectId}/publish-name`,
    method: 'get',
  }),
  updateUniqueAiObjectFromJsonRequest: (data) => ({
    url: `${BASE_URL}/unique-ai-object/${data.Id}`,
    method: 'put',
    data,
  }),
}

export default aiReportRequests
